import React from "react";
import { Box } from "@mui/material";
import { FONT_INTER } from "../../../styles/fonts";

const Tag = ({ label, sx }) => (
  <Box
    component="span"
    sx={{
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#E7F3FF",
      color: "#1957D6",
      fontFamily: FONT_INTER,
      fontSize: 14,
      fontWeight: 600,
      whiteSpace: "nowrap",
      borderRadius: "999px",
      px: "8px",
      py: "2px",
      ...sx,
    }}
  >
    {label}
  </Box>
);

export default Tag;
